/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://rprfohhq5fb3zdzdfbu4v2nj2q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-ia2rq5xkafgvjb67pnnwhx64oa",
    "aws_cloud_logic_custom": [
        {
            "name": "squareup",
            "endpoint": "https://yx317szl82.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:d84c13f3-2e09-4436-8872-b932aafcadb6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_IhEHHDrlw",
    "aws_user_pools_web_client_id": "29r1h199n8ibu6pcqprefrlrnj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "6",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "summer-classes-storage75757-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
